import { Icon, IconBlock, Section } from "main";

import { translate } from "~components/string-table";

export type QualificationsProps = {
  qualifications: string[];
  isSwingHero?: boolean;
  skillBuilderCompletedTasks?: string[];
};

export function Qualifications(props: QualificationsProps) {
  const { qualifications, isSwingHero, skillBuilderCompletedTasks = [] } = props;

  return (
    <Section title={translate("SUB_PROFILE_QUALIFICATIONS_HEADER")}>
      <div css={{ marginTop: 8 }}>
        {isSwingHero && (
          <IconBlock
            leftIcon={<Icon name="Swing Hero" />}
            content={`${translate("SUB_PROFILE_CONTACT_SWING")} ${translate("SUB_PROFILE_CONTACT_HERO")}`}
            hasDivider
          />
        )}
        {qualifications.map((qualification, idx) => (
          <div key={`${idx}-${qualification}`}>
            <IconBlock
              leftIcon={<Icon name="Verified" />}
              content={<span>{qualification}</span>}
              hasDivider
            />
          </div>
        ))}
        {skillBuilderCompletedTasks.length > 0 &&
          skillBuilderCompletedTasks.map((skill, idx) => {
            return (
              <div key={`${idx}-${skill}`}>
                <IconBlock
                  leftIcon={<Icon name="Lesson" />}
                  content={`${skill} (${translate("SUB_PROFILE_QUALIFICATIONS_SKILL_BUILDER_SUB_LABEL")})`}
                  hasDivider
                />
              </div>
            );
          })}
      </div>
    </Section>
  );
}
